import { render, staticRenderFns } from "./modalAddUser.vue?vue&type=template&id=54ac3668&"
import script from "./modalAddUser.vue?vue&type=script&lang=js&"
export * from "./modalAddUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports